import { mls } from 'lib/multilanguagesupport';
import { KTSVG, toAbsoluteUrl } from '_metronic/helpers';
import DataLakeCard from 'lib/data-connectors/dependencies/DataLakeCard/DataLakeCard';
import { useEffect, useState } from 'react';
import useStoreSchema from 'lib/reusable-components/reusableUtils/commons/useStoreSchema';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { getSheetChartsIDsTBD } from 'lib/reusable-components/reusableFunction/deleteDataDependencies';
import { analyticsMainUrl } from 'lib/data-connectors/data/dataContainersData';
import { useLocation } from 'react-router-dom';

const JoinTableCard = ({
  index,
  joinedTableData,
  allTableIDAndNamesMap,
  openEditTableInEditableMode,
}) => {
  const [selectedSheetID, setSelectedSheetID] = useState('');

  const numberOfColumnsInPrimaryTable = joinedTableData.columnSchema?.length;
  let numberOfColumnsInJoinedTables = 0;
  for (let i = 0; i < joinedTableData?.joinTableSchema?.length; i++) {
    numberOfColumnsInJoinedTables += joinedTableData.joinTableSchema[i]?.columnSchema?.length || 0;
  }
  const analyticsSchema = useStoreSchema(
    reduxConstants.STORE_NAME,
    reduxConstants.config.ANALYTICS_SCHEMA
  );
  let numberOfTablesExcludingPrimaryAndSecondaryTables =
    joinedTableData?.joinTableSchema?.length - 1;
  const handleShow = () => {
    openEditTableInEditableMode({ editableMode: false, data: joinedTableData });
  };
  const isSqlAdded = joinedTableData.sqlQuery ? true : false;
  const location = useLocation();
  const appID = location.pathname.split('/')[1];
  useEffect(() => {
    const { sheetIDsTBD } = getSheetChartsIDsTBD(
      [],
      [joinedTableData?.tableID ?? ''],
      analyticsSchema?.appSheets || {}
    );
    setSelectedSheetID(sheetIDsTBD[0] ?? '');
  }, [joinedTableData?.tableID, analyticsSchema?.appSheets]);
  return (
    <DataLakeCard
      index={index}
      settingButtonFunction={handleShow}
      titleButtonFunction={handleShow}
      title={joinedTableData.name}
      backGroundImage
      bottomButtonFunction={handleShow}
      bottomButtonTitle={mls('Go To Table')}
      description={joinedTableData.description}
    >
      {/* <p className=' fw-bold fs-5 m-0 text-muted mt-4 mb-3'>
            <strong>{mls('Connection Name')}: </strong>
            {mls(connectionName)}
          </p>
          <p className=' fw-bold fs-5 m-0 text-muted mt-4 mb-3'>
            <strong>{mls('Connection Type')}: </strong>
            {mls(connectionTypes?.[connectorType])}
          </p> */}
      <p className=' fw-bold fs-5 m-0 text-muted mt-1 mb-2'>
        <strong>{mls('Primary Table')}: </strong>
        {allTableIDAndNamesMap[joinedTableData.primaryTable] || joinedTableData.primaryTable}
      </p>
      <p className=' fw-bold fs-5 m-0 text-muted mt-0 mb-2'>
        <strong>{mls('Secondary Table')}: </strong>
        {allTableIDAndNamesMap[joinedTableData?.joinTableSchema?.[0]?.joinTableName] ||
          joinedTableData?.joinTableSchema?.[0]?.joinTableName}
      </p>
      <p className=' fw-bold fs-5 m-0 text-muted mt-0 mb-0'>
        {numberOfTablesExcludingPrimaryAndSecondaryTables ? (
          <>
            + {numberOfTablesExcludingPrimaryAndSecondaryTables} table
            {numberOfTablesExcludingPrimaryAndSecondaryTables > 1 && 's'}
          </>
        ) : null}
      </p>
      {selectedSheetID ? (
        <a
          href={`${analyticsMainUrl}/${appID}/sheets/${selectedSheetID}`}
          target='_blank'
          rel='noreferrer'
        >
          <span className='linkButton'>{mls('Go To Sheet')}</span>
        </a>
      ) : (
        <div className='noSheet text-muted'>{mls('No Sheet Connected')}</div>
      )}
      {isSqlAdded ? (
        <p className=' fw-bold fs-5 m-0 mt-4 mb-3'>
          <strong
            style={{
              color: '#155724',
              background: '#d4edda',
              padding: '.25rem .5rem',
              borderRadius: '6px',
            }}
          >
            {mls('SQL Added')}
          </strong>
        </p>
      ) : null}
    </DataLakeCard>
  );
};

export default JoinTableCard;
